import React, { useEffect, useState } from 'react';
import '../../App.css';

/**
 * Countdown overlay component
 * Shows a 5-second countdown centered over the media preview
 * Font size: 75% of container height
 * Opacity: 50%
 */
function CountdownOverlay({ onComplete }) {
  const [count, setCount] = useState(5);

  useEffect(() => {
    if (count === 0) {
      onComplete();
      return;
    }

    const timer = setTimeout(() => {
      setCount(count - 1);
    }, 1000);

    return () => clearTimeout(timer);
  }, [count, onComplete]);

  // Don't render anything when countdown reaches zero
  if (count === 0) {
    return null;
  }

  return (
    <div
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        pointerEvents: 'none',
        zIndex: 10
      }}
    >
      <div
        style={{
          fontSize: '50vh', // 50% of viewport height as a starting point
          fontWeight: 'bold',
          color: 'white',
          opacity: 0.5,
          textShadow: '0 0 20px rgba(0, 0, 0, 0.8)',
          lineHeight: 1,
          // Scale based on container height
          transform: 'scale(0.5)'
        }}
      >
        {count}
      </div>
    </div>
  );
}

export default CountdownOverlay;
